import React from "react";
import "../../admissions/group/index.css";
import Sidebar from "../../../../components/Sidebar";
import PageHeader from "../../../../components/PageHeader";
import GroupPermission from "./GroupPermission";
import PublicSecureUser from "../../../../services/system/user/secure-user-controller";
import { useSearchParams } from "react-router-dom";
import {toast} from "react-toastify";
function withParams(Component) {
    return (props) => <Component {...props} params={useSearchParams()} />;
}
class PermissionGroupManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            schoolPermission : JSON.parse(localStorage.getItem("sas_school_per")),
            listQLTS: [],
            allPermission: [],
            isUpdate: true,
            showInfo: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
            groupId: null,
            groupDes: "",
            description: null,
        };
    }
    renderAllGroup=() =>{
        let allPermission = this.state.allPermission
        return GroupPermission.AllGroup.map((groupPermission, indexX) =>
                groupPermission.isShow &&
                <div className="col-12 d-flex mb-2 row">
                    <button type="button"  style={{border: "none"}} className="col-12 p-2 mb-2 bg-info bg-gradient text-white  d-block py-2 no-border-top d-flex justify-content-between align-items-center"  onClick={() => this.hideComponent(indexX)}>
                        <span style={{textAlign: "left"}}>
                            {groupPermission.name}
                        </span>
                        {this.state.showInfo[indexX] ?<span className="fas fa-angle-down icon-arrow-side-bar" aria-hidden="true"></span>:<span className="fas fa-angle-up icon-arrow-side-bar" aria-hidden="true"></span>}
                    </button>
                    {this.state.showInfo[indexX] &&
                        <div className="col-12 d-flex mb-2 row" style={{paddingLeft: "0px", paddingRight: "0px"}}>
                            {
                                groupPermission.listPermission.map((group, subIndex) =>
                                        group.isShow &&
                                        <div className="col-md-3 col-xs-12 d-flex mb-2 row">
                                            <input
                                                type="checkbox"
                                                maxLength={255}
                                                checked={group.isClick}
                                                className="form-control shadow-none check-box-type"
                                                onChange={(event) => {
                                                    group.isClick = !group.isClick
                                                    group.listPermission.forEach(permissionInfo => {
                                                        if (group.isClick){
                                                            allPermission[permissionInfo.stt] = permissionInfo.permission
                                                        }else {
                                                            allPermission[permissionInfo.stt] = ""
                                                        }
                                                    });
                                                    this.setState({
                                                        allPermission:  allPermission
                                                    })
                                                }}
                                            /> <label className="txt-bold mb-3">{group.name}</label>
                                            {
                                                group.listPermission.map((item, indexY) =>
                                                    <div className="col-12 d-flex mb-2">
                                                        <input
                                                            type="checkbox"
                                                            maxLength={255}
                                                            checked={allPermission.includes(item.permission)}
                                                            className="form-control shadow-none check-box-type"
                                                            value={item.permission}
                                                            onChange={(event) => {
                                                                allPermission[item.stt] =  event.target.checked?event.target.value: ""
                                                                this.setState({
                                                                    allPermission:  allPermission
                                                                })
                                                                if (event.target.checked){
                                                                    let isClick = true
                                                                    group.listPermission.forEach(permissionInfo => {
                                                                        if (!allPermission.includes(permissionInfo.permission))
                                                                            isClick = false
                                                                    });
                                                                    group.isClick = isClick
                                                                }else {
                                                                    group.isClick = false
                                                                }
                                                            }}
                                                        />{item.name}
                                                    </div>
                                                )
                                            }
                                        </div>
                                )
                            }
                        </div>}
                </div>
            )
    }
    componentWillMount() {
        const [searchparams] = this.props.params;
        this.state.groupId = searchparams.get("nhom");
        this.detailGroup(this.state.groupId)
    }
    detailGroup(groupId) {
        PublicSecureUser.detailGroup(groupId, res => {
            if (res.success) {
                this.setState({
                    description:  res.data?.description,
                    listQLTS:  res.data?.permissions,
                }, ()=>{
                    this.renderDataPermission()
                })
            }else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        });
    }
    renderDataPermission(){
        let total = 0
        for (let i=0; i< GroupPermission.AllGroup.length; i++){
            let groupPermission = GroupPermission.AllGroup[i]
            let isShowAll = false
            for (let j=0; j< groupPermission.listPermission.length; j++){
                let isShowGroup = false
                let isClickGroup = true
                let listPermissionObj = groupPermission.listPermission[j]
                for (let k=0; k< listPermissionObj.listPermission.length; k++){
                    let permissionObj = listPermissionObj.listPermission[k]
                    permissionObj.isShow = this.state.schoolPermission.includes(permissionObj.permission)
                    permissionObj.stt = total
                    if (permissionObj.isShow){
                        isShowGroup = true
                    }
                    this.state.allPermission[permissionObj.stt] = ""
                    if (!this.state.listQLTS.includes(permissionObj.permission)){
                        isClickGroup = false
                    }else {
                        this.state.allPermission[permissionObj.stt] = permissionObj.permission
                    }
                    total += 1
                }
                listPermissionObj.isShow = isShowGroup
                listPermissionObj.isClick = isClickGroup
                if (isShowGroup)
                    isShowAll = true
            }
            GroupPermission.AllGroup[i].isShow = isShowAll
        }
    }
    hideComponent = (index) => {
        this.state.showInfo[index] = !this.state.showInfo[index]
        this.setState({
            showInfo:  this.state.showInfo
        })
    }
    savePermission() {
        let listItem = this.state.allPermission.filter(item => item !== "")
        let payload = {
            permissions: listItem,
            role: this.state.groupId,
        };
        PublicSecureUser.addPermissionGroup(payload, res => {
            if (res.success) {
                toast.success("Cập nhật quyền thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            } else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        });
    }
    render() {
        let {showInfo} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="group-user-management" parentClass="system-school-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                                <div className="content-loading col-12 ml-3 align-items-center"
                                     style={{display: 'block'}}>
                                    <div className="spinner-grow text-info"/>
                                </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Phân quyền nhóm người dùng"/>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="row">
                                        <div className="col-md-6 col-xs-12 d-flex mb-2">
                                            <label className="col-md-4 col-xs-12 label-item pl-0">Tên nhóm quyền:</label>
                                            <label className="col-8 label-item pl-0 txt-bold">{this.state.groupId}({this.state.description})</label>
                                        </div>
                                        <hr className="col-11 d-flex mb-2" style={{
                                            color: '#2b2b2b',
                                            backgroundColor: '#2b2b2b',
                                            height: .1,
                                            borderColor : '#2b2b2b'
                                        }}/>
                                        <div className="col-12 mb-2 d-flex row">
                                            <div className="col-6 mb-2">
                                                <label className="col-12 label-item pl-0">Danh sách các nhóm quyền</label>
                                            </div>
                                            <div className="col-6 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <button
                                                    style={{height: 35, marginRight: 12, marginBottom: 8}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.savePermission()}
                                                >
                                                    Lưu quyền
                                                </button>
                                            </div>
                                        </div>
                                        {this.renderAllGroup()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withParams(PermissionGroupManagement);
